export default __webpack_public_path__ + "static/media/img_artwork_mer_no_image.94beb6c7.svg";